import { Flex } from '@aloft/toolkit-sui';
import { Box } from '@aloft/toolkit-sui/chakra';

import { TwoLineCell } from '../../../Grid/TwoLineCell.tsx';
import { CompSelectionProperty } from '../../types.ts';

export function addressColumn(property: CompSelectionProperty) {
  const { address } = property;
  const { AddressLineText, CityName, StateCode, PostalCode } = address || {};

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Box paddingRight={2} flexGrow={1}>
        <TwoLineCell
          line1={AddressLineText ?? ''}
          line2={`${CityName}, ${StateCode} ${PostalCode}`}
        />
      </Box>
    </Flex>
  );
}
